export const siteConfig = {
  name: '亚洲视频精选平台',
  tagline: '发现最热亚洲内容',
  description: '亚洲视频一站式聚合平台，汇集来自日韩、东南亚、华语地区的精品视频内容。无论您喜爱影视剧集、综艺娱乐还是纪录短片，这里都能找到最新最热的亚洲视频资源，高清流畅，随时随地轻松观看。',
  keywords: '亚洲视频,亚洲视频在线观看,亚洲视频精选,日韩视频,华语视频,东南亚视频内容,亚洲高清视频',
  url: 'https://hpmistf.cn',
  logo: 'AsiaV精选',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '日韩专区', href: '/category/japan-korea' },
  { label: '华语精选', href: '/category/chinese' },
  { label: '东南亚', href: '/category/southeast-asia' },
  { label: '综艺娱乐', href: '/category/variety' },
  { label: '纪录短片', href: '/category/documentary' },
  { label: '关于我们', href: '/about' },
];

export const heroBanners = [
  {
    id: 1,
    title: '探索亚洲 · 发现精彩',
    subtitle: '日韩、华语、东南亚精品视频一站式聚合',
    cta: '立即探索',
    ctaLink: '/category/japan-korea',
    imageSeq: 'hero-banner-2026-01',
  },
];

export const hotRecommendations = [
  {
    id: 'hot-1',
    title: '2026年最受期待的10部韩剧',
    excerpt: '从浪漫爱情到悬疑惊悚，今年下半年的韩剧阵容令人期待。我们精选了十部必追剧集，带你提前了解剧情亮点与主演阵容。',
    category: '日韩专区',
    categorySlug: 'japan-korea',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20drama%20film%20photography%20style%20with%20soft%20natural%20lighting%2C%20elegant%20romantic%20composition%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere%2C%20rich%20cinematic%20color%20grading%20with%20amber%20highlights&width=800&height=500&seq=hot-kdrama-2026-01&orientation=landscape',
    date: '2026-08-10',
    views: 125800,
    tags: ['韩剧', '影视推荐', '2026'],
  },
  {
    id: 'hot-2',
    title: '华语纪录片《山海之间》：镜头下的中国之美',
    excerpt: '这部历时三年拍摄的纪录片，以独特的视角展现了从青藏高原到东部沿海的自然奇观与人文故事，被誉为今年最值得一看的华语纪录片。',
    category: '华语精选',
    categorySlug: 'chinese',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Chinese%20documentary%20nature%20photography%20with%20dramatic%20landscapes%2C%20mountains%20and%20rivers%2C%20soft%20golden%20hour%20lighting%2C%20epic%20cinematic%20composition%2C%20rich%20amber%20and%20earth%20tones&width=800&height=500&seq=hot-docu-china-01&orientation=landscape',
    date: '2026-08-08',
    views: 98300,
    tags: ['纪录片', '华语', '自然'],
  },
  {
    id: 'hot-3',
    title: '泰国独立电影崛起：东南亚新浪潮',
    excerpt: '近年来泰国独立电影在国际电影节上屡获殊荣，一批年轻导演用独特视角讲述东南亚故事，引领了一场引人注目的电影新浪潮。',
    category: '东南亚',
    categorySlug: 'southeast-asia',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Thai%20indie%20film%20photography%20with%20tropical%20atmosphere%2C%20soft%20natural%20lighting%20in%20Bangkok%20streets%2C%20moody%20composition%2C%20rich%20golden%20and%20earthy%20color%20grading&width=800&height=500&seq=hot-thai-cinema-01&orientation=landscape',
    date: '2026-08-06',
    views: 76200,
    tags: ['独立电影', '泰国', '东南亚'],
  },
  {
    id: 'hot-4',
    title: '日本动漫2026夏季新番全面解读',
    excerpt: '夏季新番陆续开播，从热血战斗到治愈日常，本季动漫阵容丰富多样。我们为你梳理了最值得关注的十部新番作品。',
    category: '日韩专区',
    categorySlug: 'japan-korea',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20anime%20inspired%20illustration%20with%20vibrant%20colors%2C%20soft%20lighting%2C%20dreamy%20atmosphere%2C%20artistic%20composition%2C%20rich%20warm%20amber%20and%20coral%20gradients&width=800&height=500&seq=hot-anime-2026-01&orientation=landscape',
    date: '2026-08-05',
    views: 156400,
    tags: ['动漫', '新番', '日本'],
  },
  {
    id: 'hot-5',
    title: '新加坡本土综艺：多元文化的趣味碰撞',
    excerpt: '新加坡综艺节目以其多元文化特色独树一帜，融合中华、马来、印度等文化元素，创造出别具一格的娱乐体验。',
    category: '综艺娱乐',
    categorySlug: 'variety',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Singapore%20variety%20show%20photography%20with%20multicultural%20elements%2C%20colorful%20vibrant%20lighting%2C%20dynamic%20composition%2C%20rich%20warm%20golden%20and%20coral%20tones&width=800&height=500&seq=hot-sg-variety-01&orientation=landscape',
    date: '2026-08-03',
    views: 54100,
    tags: ['综艺', '新加坡', '多元文化'],
  },
  {
    id: 'hot-6',
    title: '韩国独立音乐纪录片：K-Indie的声音地图',
    excerpt: '从弘大的地下俱乐部到济州岛的海边音乐节，这部纪录片追踪了韩国独立音乐人的创作旅程，呈现K-Pop之外的另一种音乐风景。',
    category: '纪录短片',
    categorySlug: 'documentary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20indie%20music%20documentary%20photography%20with%20intimate%20live%20performance%20lighting%2C%20moody%20club%20atmosphere%2C%20soft%20amber%20and%20deep%20shadow%20composition&width=800&height=500&seq=hot-kindie-01&orientation=landscape',
    date: '2026-08-01',
    views: 68700,
    tags: ['纪录片', '音乐', '韩国'],
  },
];

export const categories = [
  {
    slug: 'japan-korea',
    name: '日韩专区',
    description: '日剧、韩剧、动漫、J-Pop、K-Pop等日韩精品内容',
    icon: 'ri-global-fill',
    imageSeq: 'cat-jp-kr-01',
    count: 1280,
  },
  {
    slug: 'chinese',
    name: '华语精选',
    description: '华语电影、电视剧、纪录片、综艺等优质内容',
    icon: 'ri-map-pin-fill',
    imageSeq: 'cat-cn-01',
    count: 1560,
  },
  {
    slug: 'southeast-asia',
    name: '东南亚',
    description: '泰国、越南、印尼、新加坡等东南亚地区精彩视频',
    icon: 'ri-earth-fill',
    imageSeq: 'cat-sea-01',
    count: 890,
  },
  {
    slug: 'variety',
    name: '综艺娱乐',
    description: '亚洲各地热门综艺节目、真人秀、脱口秀等',
    icon: 'ri-tv-2-fill',
    imageSeq: 'cat-variety-01',
    count: 720,
  },
  {
    slug: 'documentary',
    name: '纪录短片',
    description: '深度纪录片、人文纪实、自然探索等优质内容',
    icon: 'ri-film-fill',
    imageSeq: 'cat-docu-01',
    count: 540,
  },
];

export const latestContent = [
  {
    id: 'latest-1',
    title: '越南街头美食之旅：河内篇',
    excerpt: '跟随镜头走进河内老城区的大街小巷，品尝最地道的越南河粉、春卷和滴漏咖啡，感受东南亚街头美食的独特魅力。',
    category: '东南亚',
    categorySlug: 'southeast-asia',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20Vietnamese%20street%20food%20photography%20in%20Hanoi%20old%20quarter%2C%20steaming%20pho%20bowls%2C%20natural%20ambient%20lighting%2C%20shallow%20depth%20of%20field%2C%20rich%20amber%20and%20earthy%20tones&width=400&height=280&seq=latest-vietnam-food-01&orientation=landscape',
    date: '2026-08-11',
    duration: '24:18',
    views: 32100,
  },
  {
    id: 'latest-2',
    title: '中国古风音乐MV精选：当传统遇见现代',
    excerpt: '精选十首融合中国传统乐器与现代编曲的古风音乐MV，从琵琶到电子合成器，展现华语音乐的全新可能。',
    category: '华语精选',
    categorySlug: 'chinese',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20Chinese%20traditional%20music%20photography%20with%20pipa%20instrument%2C%20soft%20dramatic%20lighting%2C%20elegant%20composition%2C%20rich%20golden%20amber%20and%20deep%20red%20accents&width=400&height=280&seq=latest-cn-music-01&orientation=landscape',
    date: '2026-08-10',
    duration: '18:45',
    views: 45600,
  },
  {
    id: 'latest-3',
    title: '《首尔深夜食堂》第三季：城市与美食的故事',
    excerpt: '跟随主持人探访首尔深夜仍在营业的小店，每一碗热汤、每一份烤肉背后，都有一个关于生活和梦想的故事。',
    category: '日韩专区',
    categorySlug: 'japan-korea',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Seoul%20night%20street%20food%20photography%20with%20steaming%20soup%20and%20grilled%20meat%2C%20intimate%20neon%20lit%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20rich%20amber%20and%20deep%20shadow%20tones&width=400&height=280&seq=latest-seoul-food-01&orientation=landscape',
    date: '2026-08-09',
    duration: '32:10',
    views: 89200,
  },
  {
    id: 'latest-4',
    title: '印尼巴厘岛：不止是度假天堂',
    excerpt: '这部短片聚焦巴厘岛传统舞蹈、手工艺和祭祀仪式，带你认识一个超越旅游手册的巴厘岛，感受其深厚的文化底蕴。',
    category: '纪录短片',
    categorySlug: 'documentary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Bali%20traditional%20dance%20photography%20with%20intricate%20costumes%2C%20temple%20background%2C%20soft%20golden%20hour%20lighting%2C%20rich%20amber%20and%20earthy%20tropical%20tones&width=400&height=280&seq=latest-bali-01&orientation=landscape',
    date: '2026-08-08',
    duration: '15:30',
    views: 28900,
  },
  {
    id: 'latest-5',
    title: '日本匠心工艺：一把折扇的诞生',
    excerpt: '从选竹、裱纸到绘制，记录京都百年老铺中一把手工折扇的完整制作过程，展现日本职人精神的极致追求。',
    category: '纪录短片',
    categorySlug: 'documentary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20Japanese%20handcraft%20photography%20of%20folding%20fan%20making%20in%20Kyoto%20workshop%2C%20soft%20natural%20window%20lighting%2C%20intimate%20detailed%20composition%2C%20rich%20amber%20and%20wood%20tones&width=400&height=280&seq=latest-jp-craft-01&orientation=landscape',
    date: '2026-08-07',
    duration: '12:55',
    views: 41300,
  },
  {
    id: 'latest-6',
    title: '马来西亚华人新年：槟城的味道',
    excerpt: '槟城是马来西亚华人文化的重要据点。这部短片记录了当地华人如何庆祝传统节日，以及那些传承了数代的美食故事。',
    category: '东南亚',
    categorySlug: 'southeast-asia',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Penang%20Malaysia%20Chinese%20festival%20photography%20with%20red%20lanterns%2C%20street%20food%20stalls%2C%20festive%20atmosphere%2C%20soft%20ambient%20lighting%2C%20rich%20amber%20and%20crimson%20tones&width=400&height=280&seq=latest-penang-01&orientation=landscape',
    date: '2026-08-06',
    duration: '20:40',
    views: 35700,
  },
];

export const faqData = [
  {
    question: '亚洲视频精选平台是什么？',
    answer: '亚洲视频精选平台是一个专注于亚洲内容的视频聚合网站，汇集来自日韩、东南亚、华语地区的精品视频资源，涵盖影视剧集、综艺娱乐、纪录短片等多种类型，为华语观众提供一站式的亚洲视频内容发现和观看体验。',
  },
  {
    question: '如何找到我感兴趣的视频内容？',
    answer: '您可以通过首页的热门推荐发现当下最受欢迎的内容，也可以点击分类入口（日韩专区、华语精选、东南亚、综艺娱乐、纪录短片）浏览特定类型的内容。此外，每篇文章都包含相关标签，方便您发现更多相关内容。',
  },
  {
    question: '平台上的视频可以下载离线观看吗？',
    answer: '目前平台主要提供在线流媒体观看服务，暂不支持视频下载功能。我们推荐您在稳定的网络环境下观看，以获得最佳的高清流畅体验。未来我们会根据用户需求考虑增加离线缓存功能。',
  },
  {
    question: '平台支持哪些设备观看？',
    answer: '亚洲视频精选平台采用响应式设计，全面支持桌面电脑、平板和手机等各类设备。无论您使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问，无需安装额外应用程序。',
  },
  {
    question: '如何向我们推荐内容或提供反馈？',
    answer: '我们非常欢迎您的建议和反馈！您可以通过"关于我们"页面的联系表单给我们留言，也可以发送邮件至我们的官方邮箱。如果您有优质内容想要推荐，请附上详细的视频信息和链接，我们的编辑团队会认真审核每一份推荐。',
  },
  {
    question: '平台上的视频内容是否都有版权授权？',
    answer: '我们高度重视知识产权保护。平台聚合的所有视频内容均来自合法授权的合作伙伴和内容创作者，确保每一部作品都得到应有的尊重和保护。如果您发现任何版权问题，请通过联系表单告知我们，我们将第一时间处理。',
  },
];

export const aboutData = {
  brandStory: {
    title: '我们的故事',
    paragraphs: [
      '亚洲视频精选平台创立于2024年，由一群热爱亚洲文化的创作者和工程师共同打造。我们观察到，尽管亚洲各国拥有极其丰富多样的影视、综艺和纪录片内容，但华语观众在寻找和发现这些内容时常常面临语言障碍和渠道分散的问题。',
      '我们的使命是打破这些障碍，构建一个真正连接亚洲各国的视频内容桥梁。从日韩的热门剧集到东南亚的独立电影，从华语地区的精品纪录片到各地的特色综艺节目，我们致力于将亚洲最精彩的内容呈现给每一位观众。',
      '经过两年多的发展，平台已经聚合了超过5000部优质视频内容，服务超过200万华语用户，成为亚洲视频内容发现领域的重要力量。',
    ],
  },
  reputation: [
    { metric: '5000+', label: '精选视频' },
    { metric: '200万+', label: '活跃用户' },
    { metric: '6个', label: '覆盖地区' },
    { metric: '98%', label: '用户好评率' },
  ],
  team: [
    { name: '陈思远', role: '创始人 & CEO', bio: '前字节跳动高级产品经理，十年内容行业经验' },
    { name: '林雅婷', role: '内容总监', bio: '资深媒体人，曾任职于NHK和KBS' },
    { name: '王浩宇', role: '技术负责人', bio: '全栈工程师，开源社区活跃贡献者' },
  ],
  contact: {
    email: 'contact@hpmistf.cn',
    address: '上海市浦东新区张江高科技园区',
    wechat: 'AsiaV精选',
  },
};